import type { WorkproductFileConfig } from "../../FileUploadModal";
const editorFiles: WorkproductFileConfig = {
  workproductType: "TipTap Document Agent",
  allowedFileTypes: [{id:"document",name:"Document",description:"Reference PDF",extensions:["pdf"],maxSizeMB:25}],
  maxFilesPerUpload:5, maxTotalSizeMB:50,
};
export const workproductFileConfigs: Record<string, WorkproductFileConfig> = {"TipTap Document Agent":editorFiles};
export const getFileConfigForWorkproduct = (_type: string) => editorFiles;
export const isWorkproductTypeSupported = (type: string) => type === "TipTap Document Agent";
